import { useActivityKindTranslation } from './useActivityKindTranslation';

export function ActivityKind({ children }: { children: string }) {
  const tKind = useActivityKindTranslation();
  return <>{tKind(children)}</>;
}
